import { Component, OnInit, OnDestroy, Inject, ViewChild, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { VideosService } from './videos.service';
import { AuthService } from '../../core/auth.service';
import { BaseService } from '../../shared/base.service';
import { AppService } from '../../app.service';
import { PopoverService } from '../../shared/popover/popover.service';
import { BaseComponent } from '../../shared/base.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { DialogComponent } from '../../dialog/dialog.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'videos-component',
    templateUrl: 'videos.component.html',
    styleUrls: ['videos.component.scss'],
})

export class VideosComponent extends BaseComponent implements OnInit, OnDestroy {
    successMessage: string = '';
    allTemplates: any;
    searchTerms: string = '';
    txtNoEmailTemplate: string = 'You have no email template.';
    clinicId = 0;
    clinic: any;
    movies = [];
    language = 'DE';
    searchInfo = {keyword: ''};
    subscribe: Subscription;
    queryParams: any;
    languages = [];

    @ViewChild(DialogComponent, {static: false}) dialog: DialogComponent;

    constructor(public authService: AuthService,
                public router: Router,
                public baseService: BaseService,
                public videosService: VideosService,
                public appService: AppService,
                public popoverService: PopoverService,
                public route: ActivatedRoute) {
        super(authService, router, baseService, appService);
    }

    ngOnInit() {
        this.subscribe = this.route.queryParams.subscribe(params => {
            this.queryParams = params;
            if(params['lang']) {
                this.language = params['lang'];
            }
        });
        this.languages = JSON.parse(localStorage.getItem('languages'));
        this.getData();
    }

    ngOnDestroy() {
        if (this.subscribe) {
            this.subscribe.unsubscribe();
        }
    }

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.movies, event.previousIndex, event.currentIndex);
        this.videosService.order(this.movies, event.previousIndex, event.currentIndex, this.language).subscribe(
            (response) => {
            });
    }

    /**
     * Search email template
     */
    search() {
        if (!this.searchTerms) {
            return this.getData();
        }
    }

    resetSearch() {
        this.searchTerms = '';
        this.getData();
    }

    getData() {
        this.appService.isLoading = true;
        this.videosService.all(this.language).subscribe((response) => {
            this.appService.isLoading = false;
            if (!response['videos'].length) {
                this.movies = [];
                return;
            }
            const videos = response['videos'].filter(
                item => item['title'].indexOf(this.searchInfo.keyword) >= 0
            );
            this.movies = videos;
        });
    }

    selectVideoBylanguage(language) {
        this.language = language;
        this.router.navigate(['support/videos'], { queryParams: {lang : language}});
        return this.getData();
    }

    openConfirmModal(params: Object) {
        this.initForm(params);

        // close the modal opened before the confirmation modal
        if (this.modal && this.modal.isShown) {
            this.hideModal();
        }

        if (!this.dialog) {
            return;
        }
        const dialog = this.dialog.openConfirm(params);
        this.isLoading = false;

        dialog.onSubmit(() => {
            this.isLoading = true;

            const url = params['apiURL'] + params['action'] + '/' + params['id']

            this.baseService.changeStatus(url, params['action'])
                .subscribe(
                    response => {
                        const message = response['message'];
                        if (message) {
                            this.getData();
                            dialog.showAlert(message);
                            this.navigateByURL(params['baseURL']);
                        }
                        this.isLoading = false;
                    },
                    error => {
                        dialog.showAlert(error.error.error);
                        this.isLoading = false;
                        this.navigateByURL(params['baseURL']);
                    }
                );
        });

        dialog.onCancel(() => {
            if (this.modal && this.modal.isShown) {
                this.hideModal();
            }
            this.navigateByURL(params['baseURL']);
            this.isLoading = false;
        });
    }

    navigateByURL(url) {
        return this.router.navigateByUrl(url);
    }

    clearSearch() {
        return this.setFilterParams('');
    }

    onSearchChange(keyword: string) {
        this.setFilterParams(keyword);
    }

    setFilterParams(keyword: string) {
        const filterParams = {
            keyword: keyword,
        };
        this.searchInfo = filterParams;
        return this.getData();
    }
}
